import React, { useEffect, useState } from "react";
import { IInvoiceState } from "../../interfaces/IInvoiceState";
import { IInvoiceType } from "../../interfaces/IInvoiceType";
import { IFeedback } from "../../interfaces/IFeedback";
import { IInvoice, invoiceSchema } from "../../interfaces/IInvoice";
import { IProject } from "../../interfaces/IProject";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, MenuItem, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { CustomeTextField } from "../core/CustomeTextField";
import { useCreateByContract, useCreateByProject, useCreateByProjectAccocation, useCreateInvoiceByMaterialOffers } from "../../hooks/data/data_invoice";
import { useCreatePartnerAllocations, useGetAllocations } from "../../hooks/data/data_allocation";
import { useGetContract } from "../../hooks/data/data_contract";
import { IContract } from "../../interfaces/IContract";
import { useGetOfferByProject } from "../../hooks/data/data_offer";

interface IProps {
    project: IProject;
    invoiceStates: IInvoiceState[];
    invoiceTypes: IInvoiceType[];
    setFeetback: Function;
    refetchFunction: Function;
}


export const InvoiceCreateDialog:React.FC<IProps> = ({
    project,
    invoiceStates,
    invoiceTypes,
    setFeetback,
    refetchFunction,

}) => {
    const getEmptyInv = () => {
        let inv = invoiceSchema.parse({})
        inv.Project = project.id;
        return inv;
    }
    const { contractArray, isLoadingContractArray, refetchContractArray } = useGetContract(project.id);
    const { allocationArray, isLoadingAllocationArray, refetchAllocationArray } = useGetAllocations(project.id);
    const { offers, isLoadingOfferByProject, refetechOfferByProject } = useGetOfferByProject(project.id);
    //
    const [newInv,setNewInv] = useState(getEmptyInv());
    const [isOpenNew,setIsOpenNew] = useState(false);
    //
    const [isOpenProgressPayment,setIsOpenProgressPayment] = useState(false);
    const [selectectContract,setSelectedContract] = useState(1);
    
    const [isOpenViaAllocation,setIsOpenViaAllocation] = useState(false);
    
    const [isOpenSelectMaterialOffer,setIsOpenSelectMaterialOffer] = useState(false);
    const [selectedMaterialOffer,setSelectedMaterialOffer] = useState<number[]>([]);

    //
    const { createByContact, isPendingCreateByContract} = useCreateByContract();
    const { createnvoiceByProject, isPendingCreatenvoiceByProject} = useCreateByProject();
    const {createByProjectAccocation, isPendingCreateByProjectAccocation } = useCreateByProjectAccocation();
    const { createInvoiceByMaterialOffers, isPendingCreateInvoiceByMaterialOffers  } = useCreateInvoiceByMaterialOffers();
    const isPending = isPendingCreatenvoiceByProject || isPendingCreateByContract || isPendingCreateByProjectAccocation || isPendingCreateInvoiceByMaterialOffers;
    //



    const handleOpen = () => {
        setNewInv(getEmptyInv());
        setIsOpenNew(true)
    }
    const handleClose = () => {
        setIsOpenNew(false);
        setIsOpenProgressPayment(false);
        setIsOpenSelectMaterialOffer(false);
    }

    useEffect(() => {
        console.log("selectedMaterialOffer")
        console.log(selectedMaterialOffer)
    },[selectedMaterialOffer])


    const handleCreate = async () => {
        setIsOpenNew(true);
        setIsOpenProgressPayment(false);
        setIsOpenViaAllocation(false);
        setIsOpenSelectMaterialOffer(false);

        try {
            await createnvoiceByProject(newInv);
            setFeetback({
                open: true,
                message: "Erfolgreich gespeichert!",
                severity: "success"
            })
            refetchFunction();
            handleClose()
        } catch (error) {
            setFeetback({
                open: true,
                message: "Es ist ein Fehler aufgetretten!",
                severity: "error"
            })
        }
    }


    const handleCreateByOffers = async () => {
        try {
            await createInvoiceByMaterialOffers({idProject: project.id, idOffers: selectedMaterialOffer});
            setFeetback({
                open: true,
                message: "Erfolgreich gespeichert!",
                severity: "success"
            })
            refetchFunction();
            handleClose()
        } catch (error) {
            setFeetback({
                open: true,
                message: "Es ist ein Fehler aufgetretten!",
                severity: "error"
            })
        }
    }


    const handleCreateByContract = async () => {
        try {
            await createByContact(selectectContract);
            setFeetback({
                open: true,
                message: "Erfolgreich gespeichert!",
                severity: "success"
            })
            refetchFunction();
            handleClose()
        } catch (error) {
            setFeetback({
                open: true,
                message: "Es ist ein Fehler aufgetretten!",
                severity: "error"
            })
        }
    }


    const handleCreateByProjectAllocation = async () => {
        console.log("HERE")
        try {
            await createByProjectAccocation(project.id);
            setFeetback({
                open: true,
                message: "Erfolgreich gespeichert!",
                severity: "success"
            })
            refetchFunction();
            handleClose()
        } catch (error) {
            setFeetback({
                open: true,
                message: "Es ist ein Fehler aufgetretten!",
                severity: "error"
            })
        }
    }

    const handleSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (
            newInv.InvoiceType === 10 
            && offers && offers.find(offer => offer.OfferMaterialPositionArray.length > 0) !== undefined
        ) {
            setSelectedMaterialOffer([]);
            setIsOpenSelectMaterialOffer(true);
            setIsOpenNew(false);
        }
        else if (
            newInv.InvoiceType === 20 
            && contractArray !== undefined 
            && contractArray.filter(contract => contract.ContractType === 20).length > 0
        ) {
            setIsOpenProgressPayment(true);
            setSelectedContract(contractArray.filter(contract => contract.ContractType === 20)[0].id);
            setIsOpenNew(false);
        } 
        else if (
            newInv.InvoiceType === 30 
            && allocationArray && allocationArray.length > 0
        ) {
            setIsOpenViaAllocation(true);
            setIsOpenNew(false);
        }
        else {
            handleCreate();
        }
    }


    return(
        <>
            <Dialog
                open={isOpenSelectMaterialOffer}
                onClose={() => setIsOpenSelectMaterialOffer(false)}
            >
                <DialogContent>
                    <Typography sx={{mb: 2}}>
                        Es wurde mindestens ein Angebot mit Materialpositionen gefunden. Wählen Sie aus, aus welchen Angeboten die Positionen übernommen werden sollen. Alternativ können Sie über „Normal anlegen“ eine leere Materialrechnung erstellen.
                    </Typography>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell width={50}/>
                                <TableCell>
                                    Angebot
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {offers?.filter(offer => offer.OfferMaterialPositionArray.length > 0).map(offer =>
                                <TableRow
                                    key={`offer-${offer.id}`}
 
                                >
                                    <TableCell>
                                        <Checkbox
                                            checked={selectedMaterialOffer.find(idOffer => offer.id === idOffer) !== undefined}
                                            onClick={() => {
                                                const testObject = selectedMaterialOffer.find(idOffer => offer.id === idOffer);
                                                if (testObject !== undefined) {
                                                    setSelectedMaterialOffer([
                                                        ...selectedMaterialOffer.filter(idOffer => offer.id !== idOffer) 
                                                    ])
                                                } else {
                                                    setSelectedMaterialOffer([
                                                        ...selectedMaterialOffer,
                                                        offer.id
                                                    ])
                                                }
                                            }  }
                                        />
                                    </TableCell>
                                    <TableCell>
                                        {offer.title}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    <Button 
                        variant="outlined"
                        onClick={() => setIsOpenProgressPayment(false)}
                    >
                        Abbruch
                    </Button>
                    <Button 
                        variant="outlined"
                        onClick={handleCreate}
                    >
                        normal anlegen
                    </Button>
                    <Button 
                        variant="contained" 
                        sx={{ minWidth: 100 }} 
                        disabled={isPending || selectedMaterialOffer.length === 0} 
                        onClick={ handleCreateByOffers}
                    >
                        {isPending ? (
                            <Box display="flex" alignItems="center" gap={1}>
                                <span>Erstellen</span>
                                <CircularProgress size={20} />
                            </Box>
                        ) : (
                            "Erstellen"
                        )}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={isOpenProgressPayment}
                onClose={() => setIsOpenProgressPayment(false)}
            >
                <DialogContent>
                    <Typography sx={{mb: 2}}>
                        Diesem Projekt ist ein oder sind mehrere Werkverträge zugeordnet. Möchten Sie die Abschlagsrechnungen und die Schlussrechnung basierend auf einem ausgewählten Werkvertrag generieren lassen?
                    </Typography>
                    <CustomeTextField
                        label="Werkvertrag"
                        attr="id"
                        object={{id:selectectContract}}
                        setObject={(value:{id:number}) => setSelectedContract(value.id)}
                        type="select"
                    >
                        {contractArray?.filter(contract => contract.ContractType === 20).map(contract =>
                            <MenuItem
                                key={`contact-20-${contract.id}`}
                                value={contract.id}
                            >
                                {contract.title}
                            </MenuItem>
                        )}
                    </CustomeTextField>
                </DialogContent>
                <DialogActions>
                    <Button 
                        variant="outlined"
                        onClick={() => setIsOpenProgressPayment(false)}
                    >
                        Abbruch
                    </Button>
                    <Button 
                        variant="outlined"
                        onClick={handleCreate}
                    >
                        normal anlegen
                    </Button>
                    <Button 
                        variant="contained" 
                        sx={{ minWidth: 100 }} 
                        disabled={isPending} 
                        onClick={ handleCreateByContract}
                    >
                        {isPending ? (
                            <Box display="flex" alignItems="center" gap={1}>
                                <span>Erstellen</span>
                                <CircularProgress size={20} />
                            </Box>
                        ) : (
                            "Erstellen"
                        )}
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={isOpenViaAllocation}
                onClose={() => setIsOpenViaAllocation(false)}
            >
                <DialogContent>
                    <Typography>
                        Diesem Projekt liegt eine Handwerkerzuordnung vor. Möchten Sie die Positionen aus der Handwerkerzuordnung in die Abschlussrechnung übernehmen?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button 
                        variant="outlined"
                        onClick={() => setIsOpenProgressPayment(false)}
                    >
                        Abbruch
                    </Button>
                    <Button 
                        variant="outlined"
                        onClick={handleCreate}
                    >
                        normal anlegen
                    </Button>
                    <Button 
                        variant="contained" 
                        sx={{ minWidth: 100 }} 
                        disabled={isPending} 
                        onClick={handleCreateByProjectAllocation}
                    >
                        {isPending ? (
                            <Box display="flex" alignItems="center" gap={1}>
                                <span>Ja</span>
                                <CircularProgress size={20} />
                            </Box>
                        ) : (
                            "Ja"
                        )}
                    </Button>
                </DialogActions>
            </Dialog>

            <Button 
                variant="outlined"
                sx={{
                    float: "right"
                }}
                onClick={handleOpen}
            >
                Neue Rechnung
            </Button>


            <Dialog
                open={isOpenNew}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Neue Rechnung</DialogTitle>
                 <form onSubmit={handleSubmit}>
                    <DialogContent>
                        <Grid container spacing={2} sx={{mt: 2}}>
                            <Grid item xs={6}>
                                <CustomeTextField
                                    attr="InvoiceState"
                                    label="Status"
                                    object={newInv}
                                    setObject={setNewInv}
                                    type="select"
                                >
                                    {invoiceStates.map(state =>
                                        <MenuItem
                                            key={`inv-state-${state.id}`}
                                            value={state.id}
                                        >
                                            {state.invoiceState}
                                        </MenuItem>
                                    )}
                                </CustomeTextField>
                            </Grid>
                            <Grid item xs={6}>
                                <CustomeTextField
                                    attr="InvoiceType"
                                    label="Art"
                                    object={newInv}
                                    setObject={(newInv:IInvoice) => {
                                        let currentType = invoiceTypes.find(type =>
                                            type.id === newInv.InvoiceType
                                        )
                                        if (currentType === undefined) {
                                            setNewInv({
                                                ...newInv
                                            }) 
                                        } else {
                                            setNewInv({
                                                ...newInv,
                                                title: (newInv.InvoiceType === 20) 
                                                    ? "1. Abschlagsrechnung"
                                                    : currentType.invoiceType
                                            })
                                        }
                                    }}
                                    type="select"
                                >
                                    {invoiceTypes.map(Type =>
                                        <MenuItem
                                            key={`inv-Type-${Type.id}`}
                                            value={Type.id}
                                        >
                                            {Type.invoiceType}
                                        </MenuItem>
                                    )}
                                </CustomeTextField>
                            </Grid>
                            <Grid item xs={12}>
                                <CustomeTextField
                                    attr="title"
                                    label="Titel"
                                    object={newInv}
                                    setObject={setNewInv}
                                    type="string"
                                    required
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button 
                            variant="outlined"
                            onClick={handleClose}
                        >
                            Abbruch
                        </Button>
                        <Button variant="contained" sx={{ minWidth: 100 }} disabled={isPending} type="submit">
                            {isPending ? (
                                <Box display="flex" alignItems="center" gap={1}>
                                    <span>Erstellen</span>
                                    <CircularProgress size={20} />
                                </Box>
                            ) : (
                                "Erstellen"
                            )}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>

        </>
    )
}